<script setup lang="ts">
import type { ComponentBrandBannerProps } from "./ComponentBrandBanner.props"
import { mapProducts } from "~/utils/mapProducts"
const props = defineProps<ComponentBrandBannerProps>()

let brandBanner: ComponentBrandBannerProps = {
  ...props
}
const { $cl } = useNuxtApp()
try {
  const dataProducts = await productsPrice($cl, props.cards)
  brandBanner.cards = mapProducts(dataProducts, null, "CONTENTFUL")
} catch (error: any) {
  // A pricing failure (e.g. Commerce Layer 429) hides the banner instead of breaking the whole page
  console.error(
    "[ComponentBrandBanner] productsPrice failed",
    error?.status ?? "",
    error?.message
  )
  brandBanner.cards = []
}
</script>

<template>
  <div class="cms-brand-banner">
    <NuxtLazyHydrate when-visible>
      <ProductBlocksBrandBlockBig
        v-if="brandBanner && brandBanner.cards.length > 0"
        v-bind="brandBanner"
      />
    </NuxtLazyHydrate>
  </div>
</template>
